<template>
  <b-modal
    :id="id"
    size="xl"
    :title="trans('create_from_sample')"
    :ok-title="trans('create')"
    :ok-disabled="!sample_id"
    :close-title="trans('close')"
    @ok="onCreate"
    @shown="onShown"
    @hide="ready = false"
  >
    <b-row>
      <b-col class="col-12 col-md-6 col-lg-5 col-xl-4">
        <div v-for="(groupSamples, group) in groupedSamples" :key="group">
          <b-form-group :label="group">
            <b-form-radio-group stacked v-model="sample_id" :disabled="busy">
              <b-form-radio v-for="sample in groupSamples || []" :key="sample.id" :value="sample.id" @change="onChangeSample(sample)">
                <span>{{ sample.name }}</span>
                <small v-if="sample_id == sample.id" class="mb-2 mt-1">
                  <div v-html="sample.description"></div>
                </small>
              </b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </div>
      </b-col>
      <b-col class="col-12 col-md-6 col-lg-7 col-xl-8">
        <b-row align-h="center">
          <b-col :class="`h-100 w-100`" :style="`min-height: ${minHeight}px; overflow: hidden;`">
            <div id="preview" ref="preview" class="w-100 h-100">
              <img src="/img/frontend/blocks/page-shadow.png" style="position: absolute; pointer-events:none; width: 90%; left: 5%; height: auto;" />
              <div id="email_preview" class="w-100 h-100">
                <iframe
                  v-if="ready && emailPreviewUrl"
                  frameborder="0"
                  :width="width"
                  :height="height"
                  :src="emailPreviewUrl"
                  :style="`
                    position: absolute;
                    z-index: 100;
                    -ms-transform: scale(${emailPreviewScale});
                    -moz-transform: scale(${emailPreviewScale});
                    -o-transform: scale(${emailPreviewScale});
                    -webkit-transform: scale(${emailPreviewScale});
                    transform: scale(${emailPreviewScale});
                    -ms-transform-origin: 0 0;
                    -moz-transform-origin: 0 0;
                    -o-transform-origin: 0 0;
                    -webkit-transform-origin: 0 0;
                    transform-origin: 0 0;`"
                ></iframe>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <p v-if="sample_id" class="mt-2">
      <i class="fa fa-fw fa-info-circle text-muted"></i>
      <em v-html="trans('page_create_from_sample_note')"></em>
    </p>

    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
  export default {
    props: {
      id: {
        type: String,
        default: 'create-page-from-sample-modal',
      },
      organization: Object,
      after: null, // after this page
      parentPageId: null, // nested under this page
      isStaff: false,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        samples: null,
        sample_id: null,
        emailPreviewUrl: null,
        emailPreviewWidth: null,
        width: 1200,
        height: 900,
        ready: false,
      }
    },
    computed: {
      serialized() {
        let sample = _.find(this.samples, {id: this.sample_id})
        sample = _.pick(sample, ['name', 'type', 'permission', 'passcode_required'])
        sample.after = this.after || null
        sample.page_id = this.parentPageId || null
        sample.is_staff = this.isStaff
        return sample
      },
      emailPreviewScale() {
        return this.emailPreviewWidth / this.width
      },
      minHeight() {
        return this.height * this.emailPreviewScale
      },
      groupedSamples() {
        let amSamples = []
        let grouped = _.reduce(this.samples, (grouped, sample) => {
          if (sample.published_to_partner == 'Activity Messenger') {
            amSamples.push(sample)
            return grouped
          }
          if (!grouped[sample.published_to_partner]) grouped[sample.published_to_partner] = []
          grouped[sample.published_to_partner].push(sample)
          return grouped
        }, {})
        grouped['Activity Messenger'] = amSamples
        return grouped
      },
    },
    methods: {
      onChangeSample(sample) {
        this.emailPreviewUrl = sample.iframe_url + '?preview=true'
      },
      onModeChange() {
        this.$nextTick(this.handleResize)
      },
      handleScroll() {
        let $preview = $('#preview')
        if ($preview.length == 0) return
        let $parent = $preview.parent()
        let $img = $preview.find('img')

        let t = Math.max(0, window.scrollY - $parent.offset().top + 10)
        t -= Math.max(0, t + $img.outerHeight() - $parent.outerHeight())
        if (t < 0 ) t = 0

        $preview.css('margin-top', t + 'px')
      },
      handleResize() {
        if (this.$refs.preview)
          this.emailPreviewWidth = this.$refs.preview.clientWidth        
      },
      onCreate(e) {
        e.preventDefault()
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/page/${this.sample_id}/duplicate`
        axios.post(url, this.serialized)
        .then(response => {
          window.location = _.iframeUrlPrefix + response.data.uri
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      onShown() {
        this.busy = false
        this.error = null
        this.samples = null
        this.sample_id = null
        this.emailPreviewUrl = null
        this.fetch()
      },
      fetch() {
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/page/samples?locale=${window.lang}`
        axios.get(url)
        .then(response => {
          this.busy = false
          this.samples = response.data
          if (!this.emailPreviewWidth) this.handleResize()
          this.ready = true
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
    },
    mounted() {
      window.createPageModal = this
    },
    created () {
      window.addEventListener('scroll', this.handleScroll)
      window.addEventListener('resize', this.handleResize)
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
      window.removeEventListener('resize', this.handleResize)
    },
  }
</script>